import React from "react"
import { Log } from "../../types/logs"

interface Props {
  log: Log
}

const LogDetails = ({ log }: Props) => {
  return (
    <div>
      {/* <h4>{log.log_name}</h4>
      <div className="bg-gray-300 p-4 mb-4">
        {JSON.stringify(log.log_content, null, 2)}
      </div>
      <div>
        <span className="uppercase text-sm">{log.log_status}</span>
      </div> */}
    </div>
  )
}

export default LogDetails
